module.exports = __webpack_public_path__ + "static/select-rectangle-be7082b1b36a1f639818e9939bf94992.png";